// Événement maison émis dès que l'identité stockée change (connexion,
// déconnexion, modification du profil).
//
// Pourquoi : plusieurs composants — la navbar en tête — lisaient l'identité
// directement dans localStorage au moment du rendu. React ne re-rend pas quand
// localStorage change, donc l'ancien nom ou l'ancienne photo restaient affichés
// jusqu'à un rechargement complet. L'événement `storage` du navigateur ne
// couvre que les AUTRES onglets, d'où celui-ci pour l'onglet courant.
export const AUTH_CHANGED_EVENT = "9achna:auth-changed";

// Lecture unique de l'identité stockée
export function readIdentity() {
  return {
    name: localStorage.getItem("authname") || "",
    picture: localStorage.getItem("authpicture") || "",
    username: localStorage.getItem("authusername") || "",
    email: localStorage.getItem("authemail") || "",
  };
}

// À appeler après toute écriture des clés auth* dans localStorage
export function notifyAuthChanged() {
  window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
}

// Toutes les clés d'identité écrites à la connexion. Elles doivent être
// effacées ENSEMBLE : ne retirer que `authToken`, comme le faisait App.js,
// laissait `authname` et `authpicture` en place — la navbar continuait donc
// d'afficher l'utilisateur connecté alors que sa session était morte, et il ne
// s'en apercevait qu'au premier clic en erreur.
export const AUTH_KEYS = [
  "authToken",
  "authemail",
  "authname",
  "authusername",
  "authphone",
  "authpicture",
];

/** Y a-t-il une session ? Le jeton fait foi, pas les informations d'affichage. */
export function hasSession() {
  try {
    return !!localStorage.getItem("authToken");
  } catch (e) {
    return false;
  }
}

/** Efface l'identité et prévient l'interface. Idempotent. */
export function clearIdentity() {
  try {
    AUTH_KEYS.forEach((k) => localStorage.removeItem(k));
  } catch (e) {
    // stockage indisponible : rien à effacer
  }
  notifyAuthChanged();
}
